(function () {
  "use strict";

  var reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  function isStaticPreview(form) {
    return (
      form.hasAttribute("data-preview-submit") ||
      Boolean(form.closest("[data-contact-preview]")) ||
      document.body.classList.contains("contact-page-preview")
    );
  }

  function getFormStatus(form) {
    var statusId = form.getAttribute("aria-describedby");
    var describedStatus = statusId ? document.getElementById(statusId) : null;

    return (
      form.querySelector("[data-form-status]") ||
      form.parentElement.querySelector("[data-form-status]") ||
      describedStatus ||
      form.querySelector(".contact-page__preview-status") ||
      form.parentElement.querySelector(".contact-page__preview-status")
    );
  }

  function announcePreviewSuccess(form) {
    var status = getFormStatus(form);
    var flow =
      form.closest("[data-contact-flow]") ||
      form.querySelector("[data-contact-flow]");

    if (status) {
      var message = form.getAttribute("data-success-message");
      if (message) status.textContent = message;

      status.hidden = false;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.setAttribute("aria-atomic", "true");
      status.setAttribute("tabindex", "-1");
    }

    if (flow && flow.contactFlowController) {
      if (status) status.hidden = true;
      flow.contactFlowController.showSuccess();
      return;
    }

    if (!status) return;

    window.requestAnimationFrame(function () {
      status.focus({ preventScroll: true });
      status.scrollIntoView({
        behavior: reducedMotionQuery.matches ? "auto" : "smooth",
        block: "nearest"
      });
    });
  }

  function enhanceForm(form) {
    if (!form || form.dataset.contactFormReady === "true") return;

    form.dataset.contactFormReady = "true";

    form.addEventListener("input", function () {
      var status = getFormStatus(form);
      if (status && isStaticPreview(form) && !status.hidden) status.hidden = true;
    });

    form.addEventListener("submit", function (event) {
      if (!isStaticPreview(form)) return;

      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      announcePreviewSuccess(form);
    });
  }

  function focusServerStatus(scope) {
    var status = scope.querySelector(
      "[data-server-form-status]:not([hidden]), [data-flow-success][role='status']:not([hidden]), .contact-page__form-status[data-server-status]:not([hidden]), .contact-page__form-status[role='status']:not([hidden]), .contact-page__form-status[role='alert']:not([hidden])"
    );

    if (!status) return;

    status.setAttribute("tabindex", "-1");
    window.requestAnimationFrame(function () {
      status.focus({ preventScroll: true });
    });
  }

  function safeBookingUrl(value) {
    if (!value) return "";

    try {
      var url = new URL(value, window.location.href);
      if (url.protocol !== "https:" && url.protocol !== "http:") return "";
      return url.href;
    } catch (error) {
      return "";
    }
  }

  function getBookingParts(control) {
    var calendar = control.closest(
      "[data-booking-calendar], [data-contact-form]"
    );
    var scope = calendar || control.closest("[data-contact-page]") || document;
    var frame = scope.querySelector(
      "[data-booking-frame], [data-contact-calendar-frame]"
    );
    var iframe = frame
      ? frame.querySelector(
          "[data-booking-iframe], [data-contact-calendar-iframe]"
        )
      : null;
    var rawUrl =
      control.getAttribute("data-booking-url") ||
      (calendar && calendar.getAttribute("data-booking-url")) ||
      (frame && frame.getAttribute("data-booking-url")) ||
      (iframe && iframe.getAttribute("data-booking-url")) ||
      control.getAttribute("href");

    return {
      frame: frame,
      iframe: iframe,
      url: safeBookingUrl(rawUrl)
    };
  }

  function enhanceBookingControl(control) {
    if (!control || control.dataset.bookingReady === "true") return;

    control.dataset.bookingReady = "true";
    control.setAttribute("aria-expanded", "false");

    control.addEventListener("click", function (event) {
      var booking = getBookingParts(control);

      // With incomplete calendar markup, preserve the control's normal link fallback.
      if (!booking.frame || !booking.iframe || !booking.url) return;

      event.preventDefault();

      if (!booking.iframe.getAttribute("src")) {
        booking.iframe.setAttribute("src", booking.url);
      }

      booking.frame.hidden = false;
      booking.frame.setAttribute("aria-live", "polite");
      booking.frame.setAttribute("tabindex", "-1");
      control.setAttribute("aria-expanded", "true");

      var loadedLabel = control.getAttribute("data-loaded-label");
      if (loadedLabel) control.textContent = loadedLabel;

      window.requestAnimationFrame(function () {
        booking.frame.focus({ preventScroll: true });
        booking.frame.scrollIntoView({
          behavior: reducedMotionQuery.matches ? "auto" : "smooth",
          block: "start"
        });
      });
    });
  }

  function setFlowPanelState(panel, isActive) {
    if (!panel) return;

    panel.classList.toggle("is-active", isActive);
    panel.hidden = !isActive;
    panel.setAttribute("aria-hidden", isActive ? "false" : "true");

    if ("inert" in panel) panel.inert = !isActive;
  }

  function flowServerSuccess(flow) {
    return flow.querySelector(
      "[data-flow-server-success]:not([hidden]), [data-flow-success][role='status']:not([hidden]), [data-server-form-success]:not([hidden]), [data-server-form-status][data-success]:not([hidden]), [data-server-form-status][role='status']:not([hidden]), .contact-page__form-status[data-server-status='success']:not([hidden])"
    );
  }

  function isMobileQuotePage(page) {
    return Boolean(
      page &&
        page.classList.contains("design-quote-page") &&
        window.matchMedia("(max-width: 599px)").matches
    );
  }

  function isKeyboardControl(control) {
    if (!control || !control.matches) return false;
    if (control.matches("textarea, select")) return true;
    if (!control.matches("input")) return false;

    return [
      "date",
      "email",
      "month",
      "number",
      "password",
      "search",
      "tel",
      "text",
      "time",
      "url",
      "week"
    ].indexOf((control.type || "text").toLowerCase()) !== -1;
  }

  function quoteFocusedControl(page) {
    var control = document.activeElement;
    return page && page.contains(control) && isKeyboardControl(control)
      ? control
      : null;
  }

  function keepQuoteAnswerVisible(page) {
    if (!page.classList.contains("is-mobile-keyboard-open")) return;

    var control = quoteFocusedControl(page);
    var panel = control
      ? control.closest(
          ".contact-flow__step.is-active, .contact-flow__review.is-active"
        )
      : null;

    if (!control || !panel) return;

    var question = panel.querySelector(
      ".contact-flow__question, .contact-flow__review-title"
    );
    var answer = control.closest(".contact-flow__control") || control;
    var viewport = window.visualViewport;
    var viewportTop = viewport ? viewport.offsetTop : 0;
    var viewportHeight = viewport ? viewport.height : window.innerHeight;
    var viewportBottom = viewportTop + viewportHeight;
    var panelRect = panel.getBoundingClientRect();
    var questionRect = question ? question.getBoundingClientRect() : null;
    var answerRect = answer.getBoundingClientRect();
    var groupTop = questionRect ? questionRect.top : answerRect.top;
    var groupBottom = answerRect.bottom;
    var safeTop = Math.max(viewportTop + 10, panelRect.top + 10);
    var safeBottom = viewportBottom - 14;

    if (groupTop >= safeTop && groupBottom <= safeBottom) return;

    if (groupBottom - groupTop <= safeBottom - safeTop) {
      panel.scrollTop += groupTop - safeTop;
    } else if (answerRect.bottom > safeBottom || answerRect.top < safeTop) {
      panel.scrollTop += answerRect.top - safeTop;
    }
  }

  function enhanceQuoteViewport(page) {
    if (!page || page.dataset.quoteViewportReady === "true") return;

    page.dataset.quoteViewportReady = "true";

    var mobileQuery = window.matchMedia("(max-width: 599px)");
    var viewport = window.visualViewport;
    var baselineHeight = 0;
    var baselineWidth = 0;
    var updateFrame = null;
    var keepVisibleTimer = null;

    function scheduleKeepVisible() {
      window.clearTimeout(keepVisibleTimer);
      keepVisibleTimer = window.setTimeout(function () {
        window.requestAnimationFrame(function () {
          keepQuoteAnswerVisible(page);
        });
      }, 60);
    }

    function updateViewport() {
      updateFrame = null;

      if (!mobileQuery.matches) {
        page.style.removeProperty("--quote-viewport-height");
        page.style.removeProperty("--quote-viewport-top");
        page.classList.remove("is-mobile-keyboard-open");
        baselineHeight = 0;
        baselineWidth = 0;
        return;
      }

      var visibleHeight = Math.round(
        viewport ? viewport.height : window.innerHeight
      );
      var visibleWidth = Math.round(
        viewport ? viewport.width : window.innerWidth
      );

      if (!visibleHeight || !visibleWidth) return;

      page.style.setProperty("--quote-viewport-height", visibleHeight + "px");

      var pageDocumentTop = page.getBoundingClientRect().top + window.scrollY;
      var viewportDocumentTop = viewport ? viewport.pageTop : window.scrollY;
      var visibleTop = Math.max(
        0,
        Math.round(viewportDocumentTop - pageDocumentTop)
      );
      page.style.setProperty("--quote-viewport-top", visibleTop + "px");

      if (!baselineHeight || Math.abs(visibleWidth - baselineWidth) > 80) {
        baselineHeight = visibleHeight;
        baselineWidth = visibleWidth;
      } else if (visibleHeight > baselineHeight) {
        baselineHeight = visibleHeight;
      }

      var focusedControl = quoteFocusedControl(page);
      var viewportReduction = baselineHeight - visibleHeight;
      var layoutReduction = Math.max(0, window.innerHeight - visibleHeight);
      var keyboardOpen = Boolean(focusedControl) &&
        Math.max(viewportReduction, layoutReduction) > 80;

      page.classList.toggle("is-mobile-keyboard-open", keyboardOpen);

      if (keyboardOpen) scheduleKeepVisible();
    }

    function scheduleUpdate() {
      if (updateFrame !== null) return;
      updateFrame = window.requestAnimationFrame(updateViewport);
    }

    page.addEventListener("focusin", function (event) {
      if (!isKeyboardControl(event.target)) return;
      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 120);
      window.setTimeout(scheduleUpdate, 320);
      window.setTimeout(scheduleUpdate, 650);
    });

    page.addEventListener("focusout", function () {
      window.setTimeout(scheduleUpdate, 120);
    });

    window.addEventListener("resize", scheduleUpdate, { passive: true });

    if (viewport) {
      viewport.addEventListener("resize", scheduleUpdate, { passive: true });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", scheduleUpdate);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(scheduleUpdate);
    }

    updateViewport();
  }

  function focusFlowPanel(panel) {
    if (!panel) return;

    var focusTarget =
      panel.querySelector("[data-flow-focus]") ||
      panel.querySelector(
        "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled])"
      ) ||
      panel.querySelector("h1, h2, h3, [data-flow-question]") ||
      panel;

    if (!focusTarget.matches("input, select, textarea, button, a[href]")) {
      focusTarget.setAttribute("tabindex", "-1");
    }

    window.requestAnimationFrame(function () {
      var quotePage = panel.closest(".design-quote-page");
      var mobileQuote = isMobileQuotePage(quotePage);

      if (mobileQuote) panel.scrollTop = 0;
      focusTarget.focus({ preventScroll: true });

      if (mobileQuote) {
        var flow = panel.closest("[data-contact-flow]");
        if (flow) {
          flow.scrollIntoView({ behavior: "auto", block: "start" });
        }
        return;
      }

      panel.scrollIntoView({
        behavior: reducedMotionQuery.matches ? "auto" : "smooth",
        block: "nearest"
      });
    });
  }

  function validateFlowStep(step) {
    if (!step) return true;

    var controls = Array.prototype.slice.call(
      step.querySelectorAll("input, select, textarea")
    );
    var firstInvalid = null;

    controls.forEach(function (control) {
      if (control.disabled || control.type === "hidden") return;
      if (!control.checkValidity() && !firstInvalid) firstInvalid = control;
    });

    if (!firstInvalid) return true;

    firstInvalid.reportValidity();
    return false;
  }

  function cleanReviewText(value, maximumLength) {
    var text = String(value || "")
      .replace(/\s+/g, " ")
      .trim();

    if (text.length <= maximumLength) return text;
    return text.slice(0, maximumLength - 3).trim() + "...";
  }

  function reviewLabel(control) {
    var explicitLabel = control.getAttribute("data-review-label");
    if (explicitLabel) return cleanReviewText(explicitLabel, 80);

    var fieldset = control.closest("fieldset");
    var legend = fieldset ? fieldset.querySelector("legend") : null;
    if (legend) return cleanReviewText(legend.textContent, 80);

    if (control.labels && control.labels.length) {
      return cleanReviewText(control.labels[0].textContent.replace("*", ""), 80);
    }

    var name = control.getAttribute("name") || "Answer";
    return cleanReviewText(
      name
        .replace(/^contact\[/, "")
        .replace(/\]$/, "")
        .replace(/[_-]+/g, " "),
      80
    );
  }

  function reviewValue(control) {
    if (control.type === "radio") {
      if (!control.checked) return "";
      if (control.labels && control.labels.length) {
        return cleanReviewText(control.labels[0].textContent, 180);
      }
    }

    if (control.type === "checkbox") {
      if (!control.checked) return "";
      return "Yes";
    }

    if (control.tagName === "SELECT") {
      var selected = control.options[control.selectedIndex];
      return selected && selected.value
        ? cleanReviewText(selected.textContent, 180)
        : "";
    }

    if (control.type === "date" && control.value) {
      var dateParts = control.value.split("-").map(Number);

      if (dateParts.length === 3 && dateParts.every(Number.isFinite)) {
        var localDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

        try {
          return new Intl.DateTimeFormat("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric"
          }).format(localDate);
        } catch (error) {
          // Fall through to the browser's ISO value when date formatting is unavailable.
        }
      }
    }

    return cleanReviewText(control.value, 180);
  }

  function populateFlowReview(summary, steps) {
    if (!summary) return;

    var answers = [];
    var seenNames = {};

    steps.forEach(function (step) {
      step.querySelectorAll("input, select, textarea").forEach(function (control) {
        if (
          control.disabled ||
          control.type === "hidden" ||
          control.hasAttribute("data-flow-summary-exclude")
        ) {
          return;
        }

        var name = control.getAttribute("name") || control.id;
        if (!name || seenNames[name]) return;

        var value = reviewValue(control);
        if (!value) return;

        seenNames[name] = true;
        answers.push({ label: reviewLabel(control), value: value });
      });
    });

    summary.replaceChildren();
    summary.setAttribute("aria-live", "polite");
    summary.setAttribute("aria-atomic", "true");

    if (!answers.length) {
      var empty = document.createElement("p");
      empty.textContent = "No answers added yet.";
      summary.appendChild(empty);
      return;
    }

    var list = document.createElement("dl");
    list.className = "contact-flow__review-list";

    answers.forEach(function (answer) {
      var item = document.createElement("div");
      item.className = "contact-flow__review-item";

      var term = document.createElement("dt");
      term.textContent = answer.label;

      var description = document.createElement("dd");
      description.textContent = answer.value;

      item.appendChild(term);
      item.appendChild(description);
      list.appendChild(item);
    });

    summary.appendChild(list);
  }

  function enhanceContactFlow(flow) {
    if (!flow || flow.dataset.contactFlowReady === "true") return;

    var form = flow.matches("form") ? flow : flow.querySelector("form");
    var welcome = flow.querySelector("[data-flow-welcome]");
    var review = flow.querySelector("[data-flow-review]");
    var summary = flow.querySelector("[data-flow-summary]");
    var success = flow.querySelector("[data-flow-success]");
    var progress = flow.querySelector("[data-flow-progress]");
    var progressBar = flow.querySelector("[data-flow-progress-bar]");
    var progressRegion = progress
      ? progress.closest(".contact-flow__topbar")
      : null;
    var steps = Array.prototype.slice
      .call(flow.querySelectorAll("[data-flow-step]"))
      .filter(function (step) {
        return !step.matches("[data-flow-review], [data-flow-success]");
      });
    var autoStart = flow.hasAttribute("data-flow-autostart");
    var quoteEndpoint = flow.getAttribute("data-quote-endpoint") || "";
    var quoteFormId = flow.getAttribute("data-quote-form-id") || "";
    var quoteSuccessUrl =
      flow.getAttribute("data-quote-success-url") ||
      "/pages/project-submission-success";

    if (!form) return;

    var serverSuccess = flowServerSuccess(flow);

    if ((!welcome || !review || !steps.length) && serverSuccess) {
      flow.dataset.contactFlowReady = "true";
      flow.classList.add("is-flow-ready");
      if (progressRegion) progressRegion.hidden = true;
      setFlowPanelState(success, true);
      success.setAttribute("role", "status");
      success.setAttribute("aria-live", "polite");
      success.setAttribute("aria-atomic", "true");
      flow.contactFlowController = {
        showSuccess: function () {
          setFlowPanelState(success, true);
          focusFlowPanel(success);
        }
      };
      return;
    }

    if (!welcome || !review || !steps.length) return;

    flow.dataset.contactFlowReady = "true";

    var currentIndex = -1;
    var reviewIndex = steps.length;
    var successIndex = steps.length + 1;
    var radioTimer = null;
    var quoteStartedAt = Date.now();
    var quoteSubmissionId = createQuoteSubmissionId();
    var quoteSubmitting = false;
    var quoteSubmitButton = review.querySelector("[data-flow-quote-submit]");
    var quoteSubmitButtonHtml = quoteSubmitButton
      ? quoteSubmitButton.innerHTML
      : "";

    function createQuoteSubmissionId() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }

      return (
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).slice(2) +
        Math.random().toString(36).slice(2)
      ).slice(0, 80);
    }

    if (autoStart) {
      var firstBackControl = steps[0].querySelector("[data-flow-back]");
      if (firstBackControl) firstBackControl.hidden = true;
    }

    function clearRadioTimer() {
      if (radioTimer === null) return;
      window.clearTimeout(radioTimer);
      radioTimer = null;
    }

    function updateProgress(index) {
      var isQuestion = index >= 0 && index <= reviewIndex;
      var questionNumber = Math.min(steps.length, Math.max(1, index + 1));
      var percentage = (questionNumber / steps.length) * 100;
      var label = "Question " + questionNumber + " of " + steps.length;

      flow.style.setProperty("--flow-progress", percentage + "%");

      if (progressRegion) {
        progressRegion.hidden = !isQuestion;
        progressRegion.setAttribute(
          "aria-hidden",
          isQuestion ? "false" : "true"
        );
      }

      if (progress) {
        progress.hidden = !isQuestion;
        progress.setAttribute("aria-hidden", isQuestion ? "false" : "true");
        progress.textContent = label;
        progress.style.setProperty("--flow-progress", percentage + "%");
      }

      if (progressBar) {
        var progressMeter = progressBar.closest("[role='progressbar']");
        progressBar.style.width = percentage + "%";
        if (!progressMeter) {
          progressMeter = progressBar;
          progressMeter.setAttribute("role", "progressbar");
        }
        progressMeter.setAttribute("aria-label", label);
        progressMeter.setAttribute("aria-valuemin", "0");
        progressMeter.setAttribute("aria-valuemax", "100");
        progressMeter.setAttribute("aria-valuenow", String(Math.round(percentage)));
      }
    }

    function show(index, shouldFocus) {
      clearRadioTimer();
      currentIndex = index;

      setFlowPanelState(welcome, index === -1);
      steps.forEach(function (step, stepIndex) {
        setFlowPanelState(step, index === stepIndex);
      });
      setFlowPanelState(review, index === reviewIndex);
      setFlowPanelState(success, index === successIndex);

      if (index === reviewIndex) populateFlowReview(summary, steps);
      updateProgress(index);

      if (!shouldFocus) return;

      if (index === -1) focusFlowPanel(welcome);
      else if (index === reviewIndex) focusFlowPanel(review);
      else if (index === successIndex) focusFlowPanel(success);
      else focusFlowPanel(steps[index]);
    }

    function advance() {
      if (currentIndex === -1) {
        show(0, true);
        return;
      }

      if (currentIndex < 0 || currentIndex >= steps.length) return;
      if (!validateFlowStep(steps[currentIndex])) return;

      show(currentIndex + 1, true);
    }

    function goBack() {
      if (currentIndex === successIndex) return;
      if (currentIndex === reviewIndex) {
        show(steps.length - 1, true);
        return;
      }
      if (currentIndex > 0) show(currentIndex - 1, true);
      else if (currentIndex === 0 && !autoStart) show(-1, true);
    }

    function showSuccess() {
      if (!success) return;
      show(successIndex, true);
      success.setAttribute("role", "status");
      success.setAttribute("aria-live", "polite");
      success.setAttribute("aria-atomic", "true");
    }

    function ensureQuoteHidden(name, value) {
      var field = form.querySelector('input[name="' + name + '"]');

      if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = name;
        form.appendChild(field);
      }

      field.value = value == null ? "" : String(value);
      return field;
    }

    function prepareQuoteMetadata() {
      ensureQuoteHidden(
        "ynt_page_url",
        window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname
      );
      ensureQuoteHidden("ynt_source_url", window.location.pathname);
      ensureQuoteHidden(
        "ynt_form_id",
        quoteFormId || "quick_packaging_quote_form"
      );
      ensureQuoteHidden("ynt_success_url", quoteSuccessUrl);
      ensureQuoteHidden("ynt_started_at", quoteStartedAt);
      ensureQuoteHidden(
        "ynt_user_agent",
        navigator.userAgent || "browser-unavailable"
      );
      ensureQuoteHidden("ynt_submission_id", quoteSubmissionId);
      ensureQuoteHidden("ynt_hp", "");
    }

    function quoteResponseError(response, json, fallback) {
      var messages =
        json && Array.isArray(json.errors) ? json.errors.filter(Boolean) : [];
      var message =
        messages.join(" ") ||
        (json && (json.error || json.message)) ||
        fallback;
      var error = new Error(message);
      error.status = response.status;
      return error;
    }

    function requestQuoteChallenge() {
      return window
        .fetch(quoteEndpoint + "?challenge=1", {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "omit",
          cache: "no-store"
        })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (json) {
              if (!response.ok || !json.ok || !json.token) {
                throw quoteResponseError(
                  response,
                  json,
                  "Secure submission could not be verified. Please try again."
                );
              }
              return json.token;
            });
        });
    }

    function postQuickQuote(payload, token) {
      payload.set("ynt_form_token", token);

      return window
        .fetch(quoteEndpoint, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "YNTQuoteFlow"
          },
          credentials: "omit",
          cache: "no-store",
          body: payload
        })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (json) {
              if (!response.ok || !json.ok) {
                throw quoteResponseError(
                  response,
                  json,
                  "Your brief could not be submitted. Please check the details and try again."
                );
              }
              return json;
            });
        });
    }

    function friendlyQuickQuoteError(error) {
      if (error && error.status === 403) {
        return "Your submission could not be securely verified. Refresh the page and try again.";
      }
      if (error && error.status === 429) {
        return "There have been too many submission attempts. Wait a few minutes and try again.";
      }
      if (error && error.status === 422 && error.message) return error.message;
      if (error && error.status === 503) {
        return "We could not finish preparing your quotation and customer account safely. Please try again in a moment.";
      }
      return "Sorry, I could not confirm your secure submission. Check your connection and try again.";
    }

    function setQuickQuoteSubmitting(busy) {
      quoteSubmitting = busy;
      form.setAttribute("aria-busy", busy ? "true" : "false");

      if (!quoteSubmitButton) return;
      quoteSubmitButton.disabled = busy;
      quoteSubmitButton.innerHTML = busy
        ? "Creating your quotation…"
        : quoteSubmitButtonHtml;
    }

    function showQuickQuoteError(message) {
      var status = review.querySelector("[data-flow-quote-status]");
      if (!status) return;

      status.textContent = message;
      status.hidden = false;
      status.focus({ preventScroll: true });
      status.scrollIntoView({
        behavior: reducedMotionQuery.matches ? "auto" : "smooth",
        block: "center"
      });
    }

    function validateQuickQuote() {
      for (var index = 0; index < steps.length; index += 1) {
        var invalidControl = steps[index].querySelector(":invalid");
        if (!invalidControl) continue;

        show(index, true);
        window.setTimeout(function () {
          invalidControl.reportValidity();
        }, 0);
        return false;
      }

      return validateFlowStep(review);
    }

    function quickQuoteReference(response) {
      return String(
        (response && response.quote && response.quote.reference) ||
          (response && response.quoteReference) ||
          ""
      ).trim();
    }

    function quickQuoteAccountUrl(response) {
      var rawUrl = String(
        (response && response.customer && response.customer.accountUrl) ||
          (response && response.customerAccountUrl) ||
          ""
      ).trim();

      if (!rawUrl) return "";

      try {
        var accountUrl = new URL(rawUrl, window.location.origin);
        return accountUrl.protocol === "https:" ? accountUrl.href : "";
      } catch (error) {
        return "";
      }
    }

    function updateQuickQuoteSuccess(response) {
      if (!success) return;

      var reference = quickQuoteReference(response);
      var accountUrl = quickQuoteAccountUrl(response);
      var accountStatus = success.querySelector("[data-flow-account-status]");
      var referenceWrap = success.querySelector("[data-flow-quote-reference]");
      var referenceValue = success.querySelector(
        "[data-flow-quote-reference-value]"
      );
      var accountLink = success.querySelector("[data-flow-account-link]");

      if (accountStatus) accountStatus.hidden = false;
      if (referenceValue) referenceValue.textContent = reference;
      if (referenceWrap) referenceWrap.hidden = !reference;

      if (accountLink) {
        if (accountUrl) accountLink.href = accountUrl;
        else accountLink.removeAttribute("href");
        accountLink.hidden = !accountUrl;
      }
    }

    function submitQuickQuote(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }

      if (quoteSubmitting || !quoteEndpoint) return;
      if (!validateQuickQuote()) return;

      prepareQuoteMetadata();
      try { if (window.YNTLeadTracking) window.YNTLeadTracking.attach(form); } catch (_) {}
      var payload = new URLSearchParams(new FormData(form));
      var status = review.querySelector("[data-flow-quote-status]");
      if (status) {
        status.hidden = true;
        status.textContent = "";
      }
      setQuickQuoteSubmitting(true);

      Promise.resolve()
        .then(requestQuoteChallenge)
        .then(function (token) {
          return postQuickQuote(payload, token);
        })
        .then(function (response) {
          try { if (window.YNTLeadTracking) window.YNTLeadTracking.confirmed(form, response); } catch (_) {}
          setQuickQuoteSubmitting(false);
          updateQuickQuoteSuccess(response);
          form.reset();
          showSuccess();
        })
        .catch(function (error) {
          setQuickQuoteSubmitting(false);
          showQuickQuoteError(friendlyQuickQuoteError(error));
        });
    }

    if (success) {
      flow.contactFlowController = {
        showSuccess: showSuccess
      };
    }

    flow.addEventListener("click", function (event) {
      var start = event.target.closest("[data-flow-start]");
      var next = event.target.closest("[data-flow-next]");
      var back = event.target.closest("[data-flow-back]");

      if (start && flow.contains(start)) {
        event.preventDefault();
        show(0, true);
      } else if (next && flow.contains(next)) {
        event.preventDefault();
        advance();
      } else if (back && flow.contains(back)) {
        event.preventDefault();
        goBack();
      }
    });

    form.addEventListener("keydown", function (event) {
      if (
        event.key !== "Enter" ||
        event.defaultPrevented ||
        event.isComposing ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        currentIndex < 0 ||
        currentIndex >= steps.length
      ) {
        return;
      }

      var control = event.target;
      var inputType = control.type ? control.type.toLowerCase() : "";
      var isSingleLineInput =
        control.tagName === "INPUT" &&
        [
          "text",
          "email",
          "url",
          "tel",
          "number",
          "search",
          "password",
          "date",
          "time",
          "month",
          "week"
        ].indexOf(inputType) !== -1;
      var isSelect = control.tagName === "SELECT";

      if (!isSingleLineInput && !isSelect) return;

      event.preventDefault();
      advance();
    });

    form.addEventListener("change", function (event) {
      var radio = event.target;
      if (
        radio.type !== "radio" ||
        currentIndex < 0 ||
        currentIndex >= steps.length ||
        !steps[currentIndex].contains(radio) ||
        !radio.checked ||
        !validateFlowStep(steps[currentIndex])
      ) {
        return;
      }

      clearRadioTimer();
      radioTimer = window.setTimeout(
        function () {
          radioTimer = null;
          if (radio.checked && steps[currentIndex].contains(radio)) advance();
        },
        reducedMotionQuery.matches ? 0 : 240
      );
    });

    form.addEventListener(
      "submit",
      function (event) {
        if (currentIndex === reviewIndex && quoteEndpoint) {
          submitQuickQuote(event);
          return;
        }
        if (currentIndex === reviewIndex) return;

        event.preventDefault();
        if (currentIndex === -1) show(0, true);
        else if (currentIndex >= 0 && currentIndex < steps.length) advance();
      },
      true
    );

    if (quoteEndpoint && quoteSubmitButton) quoteSubmitButton.type = "submit";

    flow.classList.add("is-flow-ready");

    if (serverSuccess) show(successIndex, false);
    else show(autoStart ? 0 : -1, false);
  }

  function initialise(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (context.matches && context.matches("[data-contact-page]")) roots.push(context);
    context.querySelectorAll("[data-contact-page]").forEach(function (root) {
      roots.push(root);
    });

    if (!roots.length && context === document) roots.push(document);

    roots.forEach(function (root) {
      if (root.matches && root.matches(".design-quote-page")) {
        enhanceQuoteViewport(root);
      }
      if (root.matches && root.matches("[data-contact-flow]")) {
        enhanceContactFlow(root);
      }
      root.querySelectorAll("[data-contact-flow]").forEach(enhanceContactFlow);
      root.querySelectorAll("[data-contact-form]").forEach(enhanceForm);
      root
        .querySelectorAll(
          "[data-booking-load], [data-contact-calendar-trigger]"
        )
        .forEach(enhanceBookingControl);
      root.querySelectorAll("[data-contact-timezone]").forEach(function (input) {
        if (input.value) return;

        try {
          var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (timeZone) input.value = timeZone;
        } catch (error) {
          // Leave the field empty when the browser cannot provide a time zone.
        }
      });
      focusServerStatus(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialise(event.target);
  });
})();
